  // Initialize Firebase
export const config = {
    apiKey: "AIzaSyCiiEn9-aqMOhsD9Qtc8IMhB-VUyOXnAx0",
    authDomain: "edc-dimex.firebaseapp.com",
    databaseURL: "https://edc-dimex.firebaseio.com",
    projectId: "edc-dimex",
    storageBucket: "edc-dimex.appspot.com",
    messagingSenderId: "687725435145"
  }